import {chainWalk, deepCopyObject} from "../../../util/Util";

export const updateConfigurationsInAutoLoaderAssetObject = (asset, configurations, alias) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.alias = chainWalk(() => alias.toString(), "");
    updatedAsset.assetDetails.assetAttributes.autoLoaderConfig =
        chainWalk(() => JSON.stringify(configurations.autoLoaderConfig), "[]")
    updatedAsset.assetDetails.assetAttributes.autoLoaderTestPackage =
        chainWalk(() => JSON.stringify(configurations.autoLoaderTestPackage), "[]")
    return updatedAsset;
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/datamodel/AutoLoaderAssetModelResource.js